import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionAmbassador.module.css';

// The number of columns (numColumns) affects responsive image sizes
const COLUMN_CONFIG = [
  { responsiveImageSizes: '(max-width: 767px) 100vw, 1200px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 600px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 400px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 265px' },
];
const getIndex = numColumns => numColumns - 1;
const getResponsiveImageSizes = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.responsiveImageSizes : COLUMN_CONFIG[0].responsiveImageSizes;
};

// Wine-colored 4-point sparkle icon (from Figma)
const SparkleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={css.sparkle}>
    <path d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z" fill="#8C265C"/>
  </svg>
);

/**
 * Renders the title parsing **bold** markers as wine-colored accent spans.
 * Example: "Musas que **marcan tendencia**" → "marcan tendencia" in wine color.
 */
const AccentTitle = ({ data }) => {
  if (!data?.content) return null;
  const parts = data.content.split(/\*\*(.*?)\*\*/g);
  return (
    <h2 className={css.title}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={css.titleAccent}>{part}</span>
        ) : (
          part
        )
      )}
    </h2>
  );
};

const SectionAmbassador = props => {
  const {
    sectionId,
    className,
    numColumns,
    title,
    description,
    appearance,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      rootClassName={css.root}
      className={className}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <div className={css.headerRow}>
          <div className={css.titleRow}>
            <span className={css.titleLine} />
            <AccentTitle data={title} />
            <span className={css.titleLine} />
          </div>
          <Field data={description} className={css.descriptionField} options={fieldOptions} />
        </div>
      ) : null}

      {hasBlocks ? (
        <div className={classNames(css.cardsGrid, { [css.threeColumns]: numColumns === 3 })}>
          <BlockBuilder
            ctaButtonClass={css.ambassadorCta}
            blocks={blocks}
            sectionId={sectionId}
            responsiveImageSizes={getResponsiveImageSizes(numColumns)}
            options={options}
          />
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionAmbassador;
